module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_item_message":"There are no videos registered."}}')
  delete Component.options._Ctor
}
